var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RadialChart"},[_c('apexchart',{key:_vm.chartKey,attrs:{"type":"radialBar","height":"350","options":_vm.chartOptions,"series":_vm.chartSeries}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }